export default {
    "HP": "血量",
    "MaxHP": "最大血量",
    "MP": "内力",
    "MaxMP": "最大内力",
    "AP": "精力",
    "MaxAP": "最大精力",
    "RecoverAP": "每回合回复精力",
    "Speed": "速度",
    "Physique": "体质",
    "Intelligence": "资质",
    "ZOC": null,
    "Money": "金钱",
    "Madness": "狂狷",
    "Moral": "正邪",
    "Reputation": "江湖声望",
    "YinAndYang": "阴阳",
    "Fight": "搏击",
    "Sword": "剑法",
    "Blade": "刀法",
    "Spear": "枪棍",
    "Arrow": "暗器",
    "Short": "短柄",
    "Doctor": "医术",
    "Poison": "毒术",
    "Neigong": "内功",
    "Qinggong": "轻功",
    "HurbKnowledge": "采药",
    "MineralKnowledge": "挖矿",
    "StealKnowledge": "偷窃",
    "BusinessKnowledge": "商业",
    "Injured": "内伤",
    "Wounded": "外伤",
    "Poisoned": "中毒",
    "Sealed": "封穴",
    "Confused": "迷惑",
    "Dazed": "晕眩",
    "Cramped": "分筋",
    "Sprained": "错骨",
    "Exhausted": "散功",
    "Frozen": "冰封",
    "Drunk": "醉意"
}